import React, {FunctionComponent} from "react";
import {ClubRating} from "/src/domain/challenges/ChallengeRatingData";
import ClubRow from "/src/ui/challengeRating/ratingClubs/ClubRow";
import {Grid} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from "react-i18next";
import cs from "classnames";

interface RatingClubsData {
    ratingClubs: ClubRating[];
    currentUserId?: string;
    currentSeasonId: number;
}

const RatingClubs: FunctionComponent<RatingClubsData> = ({
                                                             ratingClubs,
                                                             currentUserId,
                                                             currentSeasonId
                                                         }) => {
    const {t} = useTranslation()
    const classes = useStyles()

    if (!ratingClubs.length) return null;

    return (
        <div className={classes.container}>
            <h3 className={classes.header}>{t('ratingClubs')}</h3>
            <Grid container
                  justifyContent="center"
                  alignItems="center"
                  className={classes.itemHeader}
                  spacing={1}
            >
                <Grid item xs={1} className={classes.cell}>#</Grid>
                <Grid item xs={1} className={classes.cell}></Grid>
                <Grid item xs={3} className={classes.cell}>{t('club')}</Grid>
                <Grid item xs={2} className={classes.cell}></Grid>
                <Grid item container justifyContent="flex-end" xs={2}
                      className={classes.cell}>{t('placeInRating')}</Grid>
                <Grid item container justifyContent="flex-end" xs={2}
                      className={cs(classes.cell, classes.participantsCell)}>{t('participantsInRating')}</Grid>
            </Grid>
            {
                ratingClubs.map((club, index) => (
                    <ClubRow
                        key={club.id}
                        club={club}
                        place={index + 1}
                        currentUserId={currentUserId}
                        currentSeasonId={currentSeasonId}
                    />
                ))
            }

        </div>
    );
}

const useStyles = makeStyles((muiTheme) => ({
    container: {
        color: muiTheme.palette.primary.main,
        fontWeight: 500,
        fontSize: '0.8rem',
    },
    header: {
        fontSize: '1rem',
        fontWeight: 500,
        padding: '1.5rem 1.5rem 0.5rem',
    },
    itemHeader: {
        padding: '0.7rem 0',
        width: '100%',
        margin: '0',
    },
    cell: {
        overflowX: 'auto',
        '&:nth-last-of-type(-n+2)': {
            textAlign: 'end'
        },
    },
    participantsCell: {
        wordBreak: "break-all"
    }
}))

export default RatingClubs